import { render, staticRenderFns } from "./ModalLayout.vue?vue&type=template&id=f66f62a0&scoped=true&"
import script from "./ModalLayout.vue?vue&type=script&lang=js&"
export * from "./ModalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66f62a0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spot: require('/vercel/path0/components/icons/Spot.vue').default})
